// src/hooks/useWallet.js
import { useAccount, useConnect, useDisconnect } from "wagmi";

export default function useWallet() {
  const { address, isConnected, connector } = useAccount();
  const { connect, connectors, isLoading, pendingConnector, data } = useConnect();
  // console.log("useWalletAuth address, isConnected, activeConnector", connector);
  const { disconnect } = useDisconnect();
  //function is called  to check the actual data 
// async function name(params) {
//  let res = await connector?.getProvider()
//   console.log("useWalletAuth address, isConnected, activeConnector __provider", res?.signer?.session?.peer?.metadata?.name); // Safe{Wallet}
// }
// address&&  isConnected && name()
  return {
    address,
    isConnected,
    connect,
    connectors,
    disconnect,
    isLoading,
    pendingConnector,
    connector
  };
}
